export const CATEGORY_AXIS_LABEL_MIN_POINTS_BEFORE_SPARSE = 6;

export const CATEGORY_AXIS_TARGET_VISIBLE_LABELS = 5;

export const getCategoryAxisLabelStep = (datapointCount: number): number => {
  if (datapointCount <= 0 || datapointCount < CATEGORY_AXIS_LABEL_MIN_POINTS_BEFORE_SPARSE) {
    return 1;
  }

  return Math.max(1, Math.ceil(datapointCount / CATEGORY_AXIS_TARGET_VISIBLE_LABELS));
};

const toCategoryAxisLabelText = (value: unknown) => {
  if (value === null || value === undefined) {
    return "";
  }
  if (typeof value === "string" || typeof value === "number") {
    return String(value);
  }
  return String(value);
};

export const formatSpacedCategoryAxisLabel = ({
  datapointCount,
  value,
  index,
}: {
  datapointCount: number;
  value: unknown;
  index: number;
}): string => {
  const step = getCategoryAxisLabelStep(datapointCount);

  if (step <= 1) {
    return toCategoryAxisLabelText(value);
  }

  const alignWithStep = index % step === 0;

  if (!alignWithStep) {
    return "";
  }

  return toCategoryAxisLabelText(value);
};
